module.exports = __webpack_public_path__ + "static/media/Screenshot 2024-08-18 at 11.55.28.85f79131.png";